
import _ from 'underscore';

import GeoJSON from 'ol/format/GeoJSON';

import Notification from 'ol-ext/control/Notification';
import 'ol-ext/control/Notification.css';


import PointMenu from './pointMenu.js';
import RuleMenu from './ruleMenu.js';
import BeaconMenu from './beaconMenu.js';




var menuTemplate = require("../../../../templates/menu.handlebars");

export default class Menu {

	constructor(map, api, siteData) {
    	this.name = 'Menu';
        this.pointMenu = new PointMenu(api, siteData); 
        this.ruleMenu = new RuleMenu(api, siteData); 
        this.beaconMenu = new BeaconMenu(api, siteData); 
        this.selectIntercation;
        this.siteData = siteData;
        this.notification = new Notification({});
        this.pointSelected = [];
        this.beaconSelected = [];
        map.addControl(this.notification);

        $("#menu-container").append(menuTemplate);

        var _this = this;

        $( "#menu-close" ).bind( "click", function(event) {
            event.preventDefault();
            _this.close();
        });
        $( "#menu-save-close" ).bind( "click", function(event) {
            event.preventDefault();
            _this.close();
        });
                     
  	}

    addPoint(point){
        this.pointSelected.push(point);
    }

    setPoints(points){
        this.pointSelected = points;
    }

    removePoint(point){    
        this.pointSelected = this.pointSelected.filter(function(item) { 
            return item !== point;
        });
    }

    isPointExist(point){
        return _.find(this.pointSelected, function (p) { return p.toLowerCase() === point.toLowerCase(); }) ? true : false;
    }

    isBeaconExist(beacon){
        return _.find(this.beaconSelected, function(b) { return b.isEqual(beacon); }) ? true : false;
    }

    filterPoints(points){
        var _this = this;
        return (_.filter(points, function(point){ return !_this.pointSelected.includes(point.name) ; }));
    }

    addBeacon(beacon){
        this.beaconSelected.push(beacon);
    }

    setBeacon(beacons){
        this.beaconSelected = beacons;
    }

    removeBeacon(beacon){    
        this.beaconSelected = this.beaconSelected.filter(function(item) { 
            return !item.isEqual(beacon);
        });
    }
    

  	toString() {
        return this.name;
    }

    showNotification(text){
        var div = $('<div>').text(text);
        this.notification.show(div.get(0));
    }

    isBeaconAllowed(){
        return this.siteData.plan.ble_nav;
    }

    open(feature,selectIntercation){
        this.feature = feature;
        if(feature){
            this.selectIntercation = selectIntercation;
            $(".beco-sidebar-node").addClass('show');
            $(".beco-sidebar-node.show").parent().addClass('sidebar-active');
            this.pointMenu.open(feature,this.ruleMenu,this);
            this.ruleMenu.open(feature);
            if(this.siteData && this.isBeaconAllowed()){
                this.beaconMenu.open(feature, this);
            }
            if(feature.getProperties() && feature.getProperties().not_a_turn){
                $("#step").prop('checked', feature.getProperties().not_a_turn);
            }else{
                $("#step").prop('checked', false);
            }

            if(feature.getProperties() && feature.getProperties().published){
                $("#published").prop('checked', feature.getProperties().published);
            }else{
                $("#published").prop('checked', true);
            }

        }
        
    }

    close(){
        $(".beco-sidebar-node").removeClass('show');
        $(".beco-sidebar").parent().removeClass('sidebar-active'); 
        var selectedPoint = this.pointMenu.save();
        if(this.siteData && this.isBeaconAllowed()){
            this.beaconMenu.save();
        }
        var props = {
            not_a_turn : $("#step").is(":checked"),
            published : $("#published").is(":checked")
        };

        this.feature.setProperties(props);
        this.ruleMenu.save(selectedPoint);
        this.selectIntercation.getFeatures().clear();
        this.showNotification("Data saved successfully");

    }

}